import React from 'react';
import { DispatchJobTabNumbers } from './Dispatch';

export default class DispatchRightContentFooter extends React.Component {
    planningTabIsActive = () => {
        const { activeJobTab } = this.props;

        return activeJobTab.number === DispatchJobTabNumbers.Planning;
    };

    cancellationsTabIsActive = () => {
        const { activeJobTab } = this.props;

        return activeJobTab.number === DispatchJobTabNumbers.Cancellations;
    };

    anyPlanningJobs = () => {
        const { planningJobs } = this.props;

        return planningJobs && planningJobs.length;
    };

    anyCancellationJobs = () => {
        const { cancellationJobs } = this.props;

        return cancellationJobs && cancellationJobs.length;
    };

    getPlanningText = () => {
        const { planningJobs, planningJobsMaxRows, planningJobsFilteredCount } =
            this.props;

        return this.anyPlanningJobs()
            ? `Displaying ${planningJobs.length} of ${planningJobsMaxRows} orders (${planningJobsMaxRows - planningJobsFilteredCount} filtered).`
            : 'No orders with resource openings found for the selected filters.';
    };

    getCancellationText = () => {
        const {
            planningJobsMaxRows,
            cancellationJobs,
            cancellationJobsFilteredCount,
            cancellationJobsMaxRows,
        } = this.props;

        return this.anyCancellationJobs()
            ? `Displaying ${
                  cancellationJobs.length
              } of ${cancellationJobsMaxRows} cancellations (${
                  planningJobsMaxRows - cancellationJobsFilteredCount
              } filtered).`
            : 'No cancellations found.';
    };

    getFooterText = () => {
        const { loading, resourcesLoading, jobsLoading } = this.props;

        if (loading || resourcesLoading || jobsLoading) {
            return 'Loading...';
        }

        if (this.planningTabIsActive()) {
            return this.getPlanningText();
        }

        return this.getCancellationText();
    };

    render() {
        return (
            <div id="dispatchRightContentFooter">
                <small>{this.getFooterText()}</small>
            </div>
        );
    }
}
